export default class StorePC {
    constructor($overlay,$fixed,$storeBtn,$onlineBtn,$fontBtn){

        this.$overlay = $overlay;
        this.$fixed = $fixed;

        this.$storeBtn = $storeBtn;
        this.$onlineBtn = $onlineBtn;
        this.$fontBtn = $fontBtn;

        this.$storeList = $("#l-header__btn-store__list");
        this.$onlineList = $("#l-header__btn-online__list");
        this.$fontList = $("#l-header__top-text__size");

        this.status = { /* 開いているか監視 */
            store : false,
            online : false,
            font : false,
        }

    }
    init(){

        let _this = this;

        this.$storeBtn.hover(
            function () {
                if($(window).width() < 750) return false;

                // if(_this.status.store) return;
                // _this.status.store = true;

                let $target = _this.$storeList;
                let $closeTarget = _this.$onlineList;
                _this.store($target,$closeTarget,'show');
            },
            function () {
                if($(window).width() < 750) return false;

                // if(!_this.status.store) return;
                // _this.status.store = false;

                let $target = _this.$storeList;
                let $closeTarget = _this.$onlineList;
                _this.store($target,$closeTarget,'hide');
            }
        );
        //online
        this.$onlineBtn.hover(
            function () {
                if($(window).width() < 750) return false;
                console.log("$onlineBtn");
                let $target = _this.$onlineList;
                let $closeTarget = _this.$storeList;
                _this.store($target,$closeTarget,'show');
            },
            function () {
                if($(window).width() < 750) return false;
                let $target = _this.$onlineList;
                let $closeTarget = _this.$storeList;
                _this.store($target,$closeTarget,'hide');
            }
        );
        //font
        this.$fontBtn.hover(
            function () {
                console.log("$fontBtn");
                let $target = _this.$fontList;
                _this.font($target,'show');
            },
            function () {
                let $target = _this.$fontList;
                _this.font($target,'hide');
            }
        );

    }

    store($target,$closeTarget,type){
        switch (type) {
            case 'hide': // --------------- hide --------------- //
                // motion
                let _outSpeed = (window.innerWidth > 750)?0.12:0.4;
                TweenMax.to($target, _outSpeed, {
                        y: '-5px',
                        display: 'none',
                        opacity:0,
                        ease: Power2.easeOut
                    }
                );
                if(window.innerWidth <= 750){
                    TweenMax.to($("#c-overlay"), 0.4, {
                            display: 'none',
                            opacity:0,
                            ease: Power2.easeOut
                        }
                    );
                }

                // if(_this.open === true) return;
                // _this.$fixed.removeAttr('style');
                // // _this.meganaviResize('hide');
                // $('html,body').animate({scrollTop: _this.Position}, 1);
                // TweenMax.to(_this.$overlay, 0.12, {
                //         display: 'none',
                //         opacity:0,
                //         ease: Circ.easeOut,
                //         onComplete:function(){
                //             // _this.meganaviResize('hide');
                //         }
                //     }
                // );
                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //

                let _speed = (window.innerWidth > 750)?0.12:0.7;

                // motion
                TweenMax.to($closeTarget, _speed, {
                        y: '-5px',
                        display: 'none',
                        opacity:0,
                        ease: Power2.easeOut
                    }
                );
                // TweenLite.set($target, {
                //         y: '-5px',
                //         display: 'none',
                //         opacity:0
                //     }
                // );
                // TweenLite.set($target.children(), {
                //         y: '-10px',
                //         opacity:0
                //     }
                // );
                TweenMax.fromTo($target, _speed,
                    {
                        y: '-5px',
                        display: 'none',
                        opacity:0
                    },
                    {
                        y: '0',
                        display: 'block',
                        opacity:1,
                        ease: Power2.easeOut
                    }
                );
                TweenMax.staggerFromTo($target.children(), 0.18,
                    {
                        y: '-10px',
                        opacity:0
                    },
                    {
                        y: '0',
                        display: 'block',
                        opacity:1,
                        ease: Sine.easeOut
                    },0.03
                );

                if(window.innerWidth <= 750){
                    TweenMax.to($("#c-overlay"), 0.7, {
                            display: 'block',
                            opacity:1,
                            ease: Power2.easeOut
                        }
                    );
                }


                // if(_this.open === false) return;
                // _this.$fixed.css({'position':'relative'});
                // TweenMax.to(_this.$overlay, 0.12, {
                //         display: 'block',
                //         opacity:1,
                //         ease: Circ.easeOut,
                //         onComplete:function(){
                //             $('html,body').animate({scrollTop: 0}, 1);
                //         }
                //     }
                // );
                break; // --------------- show (end) --------------- //
        }
    }

    font($target,type){
        switch (type) {
            case 'hide': // --------------- hide --------------- //
                // motion
                TweenMax.to($target, 0.12, {
                        y: '-5px',
                        display: 'none',
                        opacity:0,
                        ease: Circ.easeOut
                    }
                );
                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //
                // motion
                TweenLite.set($target, {
                        y: '-5px',
                        display: 'none',
                        opacity:0
                    }
                );
                TweenMax.to($target, 0.12, {
                        y: '0',
                        display: 'flex',
                        opacity:1,
                        ease: Circ.easeOut
                    }
                );
                TweenMax.staggerTo($target.children(), 0.18, {
                        y: '0',
                        display: 'block',
                        opacity:1,
                        ease: Sine.easeOut
                    },0.03
                );
                break; // --------------- show (end) --------------- //
        }
    }

}